import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Item from './components/Item';
import cls from './ParameterList.module.css';

export default class extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    itemLabelClassName: PropTypes.string,
    itemValueClassName: PropTypes.string,
    schema: PropTypes.array,
    data: PropTypes.object,
  };

  static defaultProps = {
    className: '',
    schema: [],
    data: {},
  };

  render() {
    const { children, className, itemClassName, itemLabelClassName, itemValueClassName, schema, data, ...restProps } =
      this.props;

    return (
      <div className={cx(cls.list, className)} {...restProps}>
        {schema.map((itemSchema, i) => (
          <Item
            {...itemSchema}
            className={itemClassName}
            labelClassName={itemLabelClassName}
            valueClassName={itemValueClassName}
            data={data}
            // FIXME: Replace with something more robust
            key={String(i)}
          />
        ))}
      </div>
    );
  }
}
